// ============================================================================
// 📁 FILE: src/modules/ticket/services/ticketDetailService.js
// 🎯 PURPOSE:
//    API wrapper for Ticket Detail Page
//    (ticket info, comments, attachments, audit logs, assignment, status update)
// ============================================================================

import axiosClient from "../../../api/axiosClient";

// ---------------------------------------------------------------------------
// 🌐 Inject Tenant & Location Scope
// ---------------------------------------------------------------------------
function getScope() {
  return {
    tenant_id: localStorage.getItem("tenant_id"),
    location_id: localStorage.getItem("location_id"),
    user_id: localStorage.getItem("user_id"),
  };
}

function withScope(params = {}) {
  return { ...getScope(), ...params };
}

const BASE = "/ticket-management/tickets";

const ticketDetailService = {
  // -----------------------------------------------------------------------
  // 📌 GET TICKET DETAIL
  // -----------------------------------------------------------------------
  getTicket: (ticketId, params = {}) =>
    axiosClient
      .get(`${BASE}/${ticketId}`, { params: withScope(params) })
      .then((r) => r.data),

  // -----------------------------------------------------------------------
  // 💬 COMMENTS
  // -----------------------------------------------------------------------
  getComments: (ticketId, params = {}) =>
    axiosClient
      .get(`${BASE}/${ticketId}/comments`, { params: withScope(params) })
      .then((r) => r.data),

  postComment: (ticketId, payload) =>
    axiosClient
      .post(`${BASE}/${ticketId}/comments`, payload, {
        params: withScope(),
      })
      .then((r) => r.data),

  // -----------------------------------------------------------------------
  // 🔄 STATUS UPDATE
  // -----------------------------------------------------------------------
  setStatus: (ticketId, payload) =>
    axiosClient
      .put(`${BASE}/${ticketId}/status`, payload, {
        params: withScope(),
      })
      .then((r) => r.data),

  // -----------------------------------------------------------------------
  // 👤 ASSIGNMENT
  // -----------------------------------------------------------------------
  assignTicket: (ticketId, payload) =>
    axiosClient
      .put(`${BASE}/${ticketId}/assign`, payload, {
        params: withScope(),
      })
      .then((r) => r.data),

  // -----------------------------------------------------------------------
  // 📎 ATTACHMENTS
  // -----------------------------------------------------------------------
  uploadAttachment: (ticketId, formData) =>
    axiosClient
      .post(`${BASE}/${ticketId}/attachments`, formData, {
        params: withScope(),
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data),

  getAttachments: (ticketId, params = {}) =>
    axiosClient
      .get(`${BASE}/${ticketId}/attachments`, {
        params: withScope(params),
      })
      .then((r) => r.data),

  // -----------------------------------------------------------------------
  // 📜 AUDIT HISTORY
  // -----------------------------------------------------------------------
  getAudit: (ticketId, params = {}) =>
    axiosClient
      .get(`${BASE}/${ticketId}/history`, { params: withScope(params) })
      .then((r) => r.data),
};

// ---------------------------------------------------------------------------
// EXPORT
// ---------------------------------------------------------------------------
export default ticketDetailService;
